import type { AnalyticsContext, AnalyticsParams, AnalyticsProvider } from '../types'

export class ConsoleAnalyticsProvider implements AnalyticsProvider {
  readonly name = 'console'

  private context: Record<string, string | number | boolean> = {}

  track (event: string, params?: AnalyticsParams): void {
    const payload = {
      ...this.context,
      ...Object.fromEntries(
        Object.entries(params ?? {}).filter(([, value]) => value !== undefined)
      )
    }
    this.safeLog('track', event, payload)
  }

  identify (userId: string): void {
    this.context = { ...this.context, user_id: userId }
    this.safeLog('identify', userId)
  }

  setContext (context: Partial<AnalyticsContext>): void {
    const mapped: Record<string, string | number | boolean> = {}
    if (context.userId !== undefined) { mapped.user_id = context.userId }
    if (context.companyId !== undefined) { mapped.company_id = context.companyId }
    if (context.erpVersion !== undefined) { mapped.erp_version = context.erpVersion }
    if (context.environment !== undefined) { mapped.environment = context.environment }
    this.context = { ...this.context, ...mapped }
    this.safeLog('setContext', mapped)
  }

  clearIdentity (): void {
    const { user_id: _userId, company_id: _companyId, ...rest } = this.context
    this.context = rest
    this.safeLog('clearIdentity')
  }

  private safeLog (...args: unknown[]): void {
    try {
      // eslint-disable-next-line no-console
      console.info('[analytics]', ...args)
    } catch {
      // no-op
    }
  }
}
